// client/src/pages/Game/Battlefield/components/GameLog.jsx
import React, { useRef, useEffect } from 'react';
import './GameLog.css';

const GameLog = ({ log = [], onClose }) => {
  const logContainerRef = useRef(null);
  const prevLenRef = useRef(0);

  // Auto-scroll en bas UNIQUEMENT quand de vraies entrées arrivent ET que
  // l'utilisateur est déjà près du bas. Avant, chaque re-render (identité du
  // tableau changée à chaque broadcast) re-snappait en bas — impossible de
  // remonter pour relire les actions passées.
  useEffect(() => {
    const el = logContainerRef.current;
    if (!el) return;
    const grew = log.length > prevLenRef.current;
    prevLenRef.current = log.length;
    if (!grew) return;
    const nearBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 80;
    if (nearBottom) {
      el.scrollTop = el.scrollHeight;
    }
  }, [log]);

  // Format log message based on type
  const formatLogEntry = (entry) => {
    if (!entry) return null;

    const { type, message } = entry;
    
    let className = 'log-entry';
    
    switch (type) {
      case 'GAME_START':
      case 'GAME_OVER':
        className += ' log-event';
        break;
      case 'SUMMON':
      case 'SPELL':
      case 'TRAP':
      case 'EQUIP':
        className += ' log-card';
        break;
      case 'ATTACK':
      case 'DIRECT_ATTACK':
      case 'BATTLE_VICTORY':
      case 'BATTLE_DEFEAT':
      case 'BATTLE_DRAW':
        className += ' log-battle';
        break;
      case 'EFFECT_DAMAGE':
      case 'EFFECT_HEAL':
        className += ' log-effect';
        break;
      case 'PHASE_CHANGE':
        className += ' log-phase';
        break;
      case 'DRAW':
        className += ' log-draw';
        break;
      case 'ERROR':
        className += ' log-error';
        break;
      default:
        break;
    }
    
    return (
      <div className={className}>
        <span className="log-message">{message}</span>
      </div>
    );
  };

  return (
    <div className="game-log-overlay" onClick={onClose}>
    <div className="game-log" onClick={(e) => e.stopPropagation()}>
      <div className="game-log-header">
        <h3>Journal de combat</h3>
        {/* Ajout du bouton de fermeture */}
        <button 
          className="game-log-close-button"
          onClick={onClose}
          style={{
            position: 'absolute',
            right: '10px',
            top: '10px',
            backgroundColor: 'transparent',
            border: 'none',
            color: 'white',
            fontSize: '18px',
            cursor: 'pointer'
          }}
        >
          ✕
        </button>
      </div>
      <div className="game-log-content" ref={logContainerRef}>
        {log.length === 0 ? (
          <div className="log-empty">Le combat n'a pas encore commencé.</div>
        ) : (
          log.map((entry, index) => (
            <div key={`log-${index}`} className="log-item">
              {formatLogEntry(entry)}
            </div>
          ))
        )}
      </div>
    </div>
    </div>
  );
};

export default GameLog;